module.exports = __webpack_public_path__ + "img/412.9a1ff48c.jpg";